import { useTranslation } from '@msdk/common'
import { CardBody } from '@msdk/ui'
import { useDocument } from 'state/documents'

interface Props {
  entityName: string
  entityId: string
  file: string
}

export function DocumentContent(props: Props) {
  const t = useTranslation()
  const doc = useDocument(props.entityName, props.entityId, props.file)
  const content =
    typeof doc === 'string'
      ? doc
      : doc.status === 404
      ? t('LBL_DOCUMENT_VIEWER_UNAVAILABLE', 'This document is no more available.')
      : t('LBL_DOCUMENT_VIEWER_ERROR', 'Something went wrong while loading the document.')

  return (
    <CardBody
      dangerouslySetInnerHTML={{
        __html: content,
      }}
    ></CardBody>
  )
}
